import React, { useEffect, useState } from "react";
import FormulairesAntecedents from "./Antecedents/FormulairesAntecedents";
import ModalUpload from "./ModalUpload/ModalUpload";
import Bloc3 from "./bloc3/Bloc3";
import { Grid, Segment, Container, Card } from "semantic-ui-react";
import { server } from "../../App";
import axios from "axios";
import ModalUpdatePatient from "./ModalUpdatePatient/ModalUpdatePatient";
import ModalAddToWaitingList from "./ModalProductPayment/ModalAddToWaitingList";
import ModalPayment from "./ModalProductPayment/ModalPayment";
import ModalPaymentHistoric from "./ModalProductPayment/ModalPaymentHistoric";
import ModalAntecedents from "./Antecedents/ModalAntecedents";
import { useWindowSize, useDebounce } from "react-use";
import moment from "moment";
import IntervalReady from "../PatienWaitingTime/IntervalReady";
import "ag-grid-community/dist/styles/ag-theme-balham.css";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/dist/styles/ag-grid.css";
import { toast } from "react-toastify";
import {
  selectPatientelleGrid,
  fetch_products,
} from "../../features/patientelle/patientelleSlice";
import { UploadCounter } from "../../features/counter/counterSlice";
import { useNavigate } from "react-router-dom";

import { useSelector, useDispatch } from "react-redux";
import SpeedDialComponent from "../SpeedDial/SpeedDialComponent"
import { AutoComplete } from "antd";
import CrudOptions from "./CrudOptions"

function Consultation() {
  let dispatch = useDispatch();
  let navigate = useNavigate();
  const PatientelleState = useSelector(selectPatientelleGrid);
  const [questionnaireData, setQuestionnaireData] = useState([]);
  const { width, height } = useWindowSize();
  const [NewData, setNewData] = useState({});
  const [OptionsAllergie, setOptionsAllergie] = useState([])
  const [OptionsPhatologie, setOptionsPhatologie] = useState([])
  const [PathoAllergie, setPathoAllergie] = useState([
    {
      pathologie_principale: "",
      allergie_connue: "",
    },
  ]);
  // ag grid state
  const [gridApi, setGridApi] = useState(null);
  const [, setGridColumnApi] = useState(null);

  sessionStorage.setItem("ID_Session", PatientelleState.idpatient);
  let date_De_consultation = moment().format("YYYY-MM-DD");
  let date_Lisible = moment().format("DD/MM/YYYY");



  async function getALLDropdown_Options(category) {
    await axios
      .get(`${server}Dropdown_Options/GetAllOptions/${category}`, {
        headers: {
          jwtoken: sessionStorage.token,
        },
      })
      .then((response) => {
        if (category === 1) {
          setOptionsAllergie(response.data)
        } else {
          setOptionsPhatologie(response.data)
        }

      });
  }

  useEffect(() => {
    getALLDropdown_Options(1)
    getALLDropdown_Options(2)
  }, [])

  const onSelect1 = (data) => {

    let x = { allergie_connue: data, pathologie_principale: PathoAllergie[0]?.pathologie_principale }

    axios({
      method: "put",
      responseType: "json",
      url: `${server}users/UpdateAllergiePathologie/${PatientelleState.idpatient}`,
      data: x,
      headers: {
        jwtoken: sessionStorage.token,
      },
    })
      .then(() =>

        setPathoAllergie([x])


      )
      .catch((err) => {
        console.log(err);
      });
  };
  const onSelect2 = (data) => {

    let x = { allergie_connue: PathoAllergie[0]?.allergie_connue, pathologie_principale: data }

    axios({
      method: "put",
      responseType: "json",
      url: `${server}users/UpdateAllergiePathologie/${PatientelleState.idpatient}`,
      data: x,
      headers: {
        jwtoken: sessionStorage.token,
      },
    })
      .then(() =>

        setPathoAllergie([x])

      )
      .catch((err) => {
        console.log(err);
      });
  };

  const onChange1 = (data) => {

    let x = { allergie_connue: data, pathologie_principale: PathoAllergie[0]?.pathologie_principale }
    setPathoAllergie([x])


  };
  const onChange2 = (data) => {

    let x = { allergie_connue: PathoAllergie[0]?.allergie_connue, pathologie_principale: data }
    setPathoAllergie([x])

  };


  const [,] = useDebounce(
    () => {

      axios({
        method: "put",
        responseType: "json",
        url: `${server}users/UpdateAllergiePathologie/${PatientelleState.idpatient}`,
        data: PathoAllergie[0],
        headers: {
          jwtoken: sessionStorage.token,
        },
      })
        .then(() => { })
        .catch((err) => {
          toast.error("Données non sauvegardé", {
            position: toast.POSITION.BOTTOM_RIGHT,
          });
        });

    },
    500,
    [PathoAllergie]
  );

  const handleKeyDown = (event) => {
    // if (event.ctrlKey && event.key === "Enter") {
    if (event.key === "Enter") {

      let x = { value: PathoAllergie[0]?.allergie_connue?.toUpperCase(), category: 1 }

      axios({
        method: "post",
        responseType: "json",
        url: `${server}Dropdown_Options`,
        data: x,
        headers: {
          jwtoken: sessionStorage.token,
        },
      })
        .then(() => getALLDropdown_Options(1)

        )
        .catch((err) => {
          console.log(err);
        });

    }
  };
  const handleKeyDown2 = (event) => {
    // if (event.ctrlKey && event.key === "Enter") {
    if (event.key === "Enter") {

      let x = { value: PathoAllergie[0]?.pathologie_principale?.toUpperCase(), category: 2 }

      axios({
        method: "POST",
        responseType: "json",
        url: `${server}Dropdown_Options`,
        data: x,
        headers: {
          jwtoken: sessionStorage.token,
        },
      })
        .then(() => getALLDropdown_Options(2)

        )
        .catch((err) => {
          console.log(err);
        });

    }
  };





  async function getALLDocsOneUser() {
    await axios
      .get(`${server}UploadMedia/${PatientelleState.idpatient}`, {
        headers: {
          jwtoken: sessionStorage.token,
        },
      })
      .then((response) => {
        dispatch(UploadCounter(response.data.length));
      });
  }
  useEffect(
    () => {
      getALLDocsOneUser();
    },
    // eslint-disable-next-line
    []
  );

  async function GetAllergiePathologie() {
    if (
      PatientelleState.idpatient !== undefined &&
      PatientelleState.idpatient !== ""
    ) {
      await axios
        .get(
          `${server}users/GetAllergiePathologie/${PatientelleState.idpatient}`,
          {
            headers: {
              jwtoken: sessionStorage.token,
            },
          }
        )
        .then((response) => {
          // dispatch({ type: "FETCH_SUCCESS", payload: response.data });
          //   setAllergie(response.data[0].allergie_connue)
          //   setPathologie(response.data[0].pathologie_principale)
          setPathoAllergie(response.data);

          // getDossierData(response.data)
        })
        .catch((error) => {
          console.log(error);
          // dispatch({ type: "FETCH_ERROR", payload: error.response });
        });
    }
  }

  async function getAtesData(params) {
    let url = `${server}actes/ActesOneUserAtDate/${date_De_consultation}/${PatientelleState.idpatient}`;
    axios
      .get(url, {
        headers: {
          jwtoken: sessionStorage.token,
        },
      })
      .then((response) => {
        // setAtesData(response.data);
        dispatch(fetch_products(response.data));
      })
      .catch((error) => {
        console.error(error);
      });
  }

  useEffect(
    () => {
      getAtesData();
      GetAllergiePathologie();
      getQuestionsOneUser22();
    },
    // eslint-disable-next-line
    []
  );

  useEffect(
    () => {
      if (PatientelleState.idpatient === undefined) {
        returnToWaitingList();
      }
      return undefined;
    },
    // eslint-disable-next-line
    []
  );

  function returnToWaitingList(params) {
    navigate(-1);
  }

  async function getQuestionsOneUser22() {
    if (
      PatientelleState.idpatient !== undefined &&
      PatientelleState.idpatient !== ""
    ) {
      await axios
        .get(`${server}users/questions/${PatientelleState.idpatient}`, {
          headers: {
            jwtoken: sessionStorage.token,
          },
        })
        .then((response) => {
          setNewData(response.data);
        })
        .catch((error) => {
          console.error(error);
        });
    }
  }

  const columnDefs = [
    {
      headerName: "Pathologie principale",
      field: "pathologie_principale",
      cellClass: "pathologie_Titre_CSS",
    },
    {
      headerName: "Allergie connue",
      field: "allergie_connue",
      cellClass: "allergie_Titre_CSS",
    },
  ];

  const defaultColDef = {
    editable: true,

    flex: 1,

    minWidth: 100,

    resizable: true,
    suppressMovable: true,
  };

  const onGridReady = (params) => {
    setGridColumnApi(params.columnApi);
    setGridApi(params.api);
    gridApi?.resetRowHeights();
  };

  const onCellValueChanged = async (e) => {
    let clientArray = e.api.getSelectedRows();

    axios({
      method: "put",
      responseType: "json",
      url: `${server}users/UpdateAllergiePathologie/${PatientelleState.idpatient}`,
      data: clientArray[0],
      headers: {
        jwtoken: sessionStorage.token,
      },
    })
      .then(() => { })
      .catch((err) => {
        console.log(err);
      });
  };

  let {
    Familiauxametropie_forte,
    FamiliauxautresCom,
    Familiauxglaucome,
    Familiauxkeratocone,
    Familiauxretinopathie,
    Familiauxstrabisme,
    Generauxallergies,
    Generauxanticoagulants,
    Generauxasthme,
    GenerauxautresCom,
    Generauxcardiopathie,
    GenerauxdiabeteID,
    GenerauxdiabeteIDcom,
    GenerauxdiabeteNID,
    GenerauxdiabeteNIDcom,
    Generauxdyslipidemie,
    Generauxdysthyroidie,
    Generauxgrossesse,
    Generauxhta,
    Generauxobesite,
    Generauxtabac,
    OphtalmoMyopieOD,
    OphtalmoMyopieODcom,
    OphtalmoMyopieOG,
    OphtalmoMyopieOGcom,
    OphtalmoTraitement_amblyopie,
    OphtalmoametropieForteOD,
    OphtalmoametropieForteODcom,
    OphtalmoametropieForteOG,
    OphtalmoametropieForteOGcom,
    OphtalmoastigmatismeOD,
    OphtalmoastigmatismeODcom,
    OphtalmoastigmatismeOG,
    OphtalmoastigmatismeOGcom,
    Ophtalmoautomedication_collyreOD,
    Ophtalmoautomedication_collyreODcom,
    Ophtalmoautomedication_collyreOG,
    Ophtalmoautomedication_collyreOGcom,
    OphtalmoautresCom,
    Ophtalmochir_glaucomeOD,
    Ophtalmochir_glaucomeODcom,
    Ophtalmochir_glaucomeOG,
    Ophtalmochir_glaucomeOGcom,
    Ophtalmochir_pterygionOD,
    Ophtalmochir_pterygionODcom,
    Ophtalmochir_pterygionOG,
    Ophtalmochir_pterygionOGcom,
    Ophtalmochir_strabismeOD,
    Ophtalmochir_strabismeODcom,
    Ophtalmochir_strabismeOG,
    Ophtalmochir_strabismeOGcom,
    Ophtalmochirurgie_de_cataracteOD,
    Ophtalmochirurgie_de_cataracteODcom,
    Ophtalmochirurgie_de_cataracteOG,
    Ophtalmochirurgie_de_cataracteOGcom,
    Ophtalmochirurgie_palpebraleOD,
    Ophtalmochirurgie_palpebraleODcom,
    Ophtalmochirurgie_palpebraleOG,
    Ophtalmochirurgie_palpebraleOGcom,
    Ophtalmochirurgie_refractiveOD,
    Ophtalmochirurgie_refractiveODcom,
    Ophtalmochirurgie_refractiveOG,
    Ophtalmochirurgie_refractiveOGcom,
    Ophtalmochirurgie_vitreo_retinienneOD,
    Ophtalmochirurgie_vitreo_retinienneODcom,
    Ophtalmochirurgie_vitreo_retinienneOG,
    Ophtalmochirurgie_vitreo_retinienneOGcom,
    OphtalmodcrsOD,
    OphtalmodcrsODcom,
    OphtalmodcrsOG,
    OphtalmodcrsOGcom,
    Ophtalmodecollement_de_retineOD,
    Ophtalmodecollement_de_retineODcom,
    Ophtalmodecollement_de_retineOG,
    Ophtalmodecollement_de_retineOGcom,
    OphtalmoglaucomeOD,
    OphtalmoglaucomeODcom,
    OphtalmoglaucomeOG,
    OphtalmoglaucomeOGcom,
    OphtalmohypermetropieOD,
    OphtalmohypermetropieODcom,
    OphtalmohypermetropieOG,
    OphtalmohypermetropieOGcom,
    Ophtalmoivt_anti_vegfOD,
    Ophtalmoivt_anti_vegfODcom,
    Ophtalmoivt_anti_vegfOG,
    Ophtalmoivt_anti_vegfOGcom,
    OphtalmokeratconeOD,
    OphtalmokeratconeODcom,
    OphtalmokeratconeOG,
    OphtalmokeratconeOGcom,
    Ophtalmolaser_dehiscences_retinienneOD,
    Ophtalmolaser_dehiscences_retinienneODcom,
    Ophtalmolaser_dehiscences_retinienneOG,
    Ophtalmolaser_dehiscences_retinienneOGcom,
    OphtalmopprOD,
    OphtalmopprODcom,
    OphtalmopprOG,
    OphtalmopprOGcom,
    Ophtalmoretinopathie_diabetiqueOD,
    Ophtalmoretinopathie_diabetiqueODcom,
    Ophtalmoretinopathie_diabetiqueOG,
    Ophtalmoretinopathie_diabetiqueOGcom,
    OphtalmostrabismeOD,
    OphtalmostrabismeODcom,
    OphtalmostrabismeOG,
    OphtalmostrabismeOGcom,
    Ophtalmotraumatisme_oculaireOD,
    Ophtalmotraumatisme_oculaireODcom,
    Ophtalmotraumatisme_oculaireOG,
    Ophtalmotraumatisme_oculaireOGcom,
    Ophtalmotravail_prolongee_en_vpCheck,
    OphtalmoVisibleametropieForte,
    OphtalmoVisibleastigmatisme,
    OphtalmoVisibleautomedication_collyre,
    OphtalmoVisiblechir_glaucome,
    OphtalmoVisiblechir_pterygion,
    OphtalmoVisiblechir_strabisme,
    OphtalmoVisiblechirurgie_de_cataracte,
    OphtalmoVisiblechirurgie_palpebrale,
    OphtalmoVisiblechirurgie_refractive,
    OphtalmoVisiblechirurgie_vitreo_retinienne,
    OphtalmoVisibledcrs,
    OphtalmoVisibledecollement_de_retine,
    OphtalmoVisibleglaucome,
    OphtalmoVisiblehypermetropie,
    OphtalmoVisibleivt_anti_vegf,
    OphtalmoVisiblekeratcone,
    OphtalmoVisiblelaser_dehiscences_retinienne,
    OphtalmoVisiblemyopie,
    OphtalmoVisibleppr,
    OphtalmoVisibleretinopathie_diabetique,
    OphtalmoVisiblestrabisme,
    OphtalmoVisibletraitement_amblyopie,
    OphtalmoVisibletraumatisme_oculaire,
    OphtalmoVisibletravail_prolongee_en_vp,
    OphtalmoVisibleautres,
    GenerauxVisiblecardiopathie,
    GenerauxVisibleallergies,
    GenerauxVisibletabac,
    GenerauxVisibledysthyroidie,
    GenerauxVisibleobesite,
    GenerauxVisibledyslipidemie,
    GenerauxVisiblegrossesse,
    GenerauxVisibleanticoagulants,
    GenerauxVisibleasthme,
    GenerauxVisiblehta,
    GenerauxVisiblediabete,
    GenerauxVisibleautres,
    FamiliauxVisibleAmetropie_forte,
    FamiliauxVisibleautres,
    FamiliauxVisibleglaucome,
    FamiliauxVisiblekeratocone,
    FamiliauxVisibleretinopathie,
    FamiliauxVisiblestrabisme,
  } = NewData;

  let toClean = {
    Familiauxametropie_forte,
    FamiliauxautresCom,
    Familiauxglaucome,
    Familiauxkeratocone,
    Familiauxretinopathie,
    Familiauxstrabisme,
    Generauxallergies,
    Generauxanticoagulants,
    Generauxasthme,
    GenerauxautresCom,
    Generauxcardiopathie,
    GenerauxdiabeteID,
    GenerauxdiabeteIDcom,
    GenerauxdiabeteNID,
    GenerauxdiabeteNIDcom,
    Generauxdyslipidemie,
    Generauxdysthyroidie,
    Generauxgrossesse,
    Generauxhta,
    Generauxobesite,
    Generauxtabac,
    OphtalmoMyopieOD,
    OphtalmoMyopieODcom,
    OphtalmoMyopieOG,
    OphtalmoMyopieOGcom,
    OphtalmoTraitement_amblyopie,
    OphtalmoametropieForteOD,
    OphtalmoametropieForteODcom,
    OphtalmoametropieForteOG,
    OphtalmoametropieForteOGcom,
    OphtalmoastigmatismeOD,
    OphtalmoastigmatismeODcom,
    OphtalmoastigmatismeOG,
    OphtalmoastigmatismeOGcom,
    Ophtalmoautomedication_collyreOD,
    Ophtalmoautomedication_collyreODcom,
    Ophtalmoautomedication_collyreOG,
    Ophtalmoautomedication_collyreOGcom,
    OphtalmoautresCom,
    Ophtalmochir_glaucomeOD,
    Ophtalmochir_glaucomeODcom,
    Ophtalmochir_glaucomeOG,
    Ophtalmochir_glaucomeOGcom,
    Ophtalmochir_pterygionOD,
    Ophtalmochir_pterygionODcom,
    Ophtalmochir_pterygionOG,
    Ophtalmochir_pterygionOGcom,
    Ophtalmochir_strabismeOD,
    Ophtalmochir_strabismeODcom,
    Ophtalmochir_strabismeOG,
    Ophtalmochir_strabismeOGcom,
    Ophtalmochirurgie_de_cataracteOD,
    Ophtalmochirurgie_de_cataracteODcom,
    Ophtalmochirurgie_de_cataracteOG,
    Ophtalmochirurgie_de_cataracteOGcom,
    Ophtalmochirurgie_palpebraleOD,
    Ophtalmochirurgie_palpebraleODcom,
    Ophtalmochirurgie_palpebraleOG,
    Ophtalmochirurgie_palpebraleOGcom,
    Ophtalmochirurgie_refractiveOD,
    Ophtalmochirurgie_refractiveODcom,
    Ophtalmochirurgie_refractiveOG,
    Ophtalmochirurgie_refractiveOGcom,
    Ophtalmochirurgie_vitreo_retinienneOD,
    Ophtalmochirurgie_vitreo_retinienneODcom,
    Ophtalmochirurgie_vitreo_retinienneOG,
    Ophtalmochirurgie_vitreo_retinienneOGcom,
    OphtalmodcrsOD,
    OphtalmodcrsODcom,
    OphtalmodcrsOG,
    OphtalmodcrsOGcom,
    Ophtalmodecollement_de_retineOD,
    Ophtalmodecollement_de_retineODcom,
    Ophtalmodecollement_de_retineOG,
    Ophtalmodecollement_de_retineOGcom,
    OphtalmoglaucomeOD,
    OphtalmoglaucomeODcom,
    OphtalmoglaucomeOG,
    OphtalmoglaucomeOGcom,
    OphtalmohypermetropieOD,
    OphtalmohypermetropieODcom,
    OphtalmohypermetropieOG,
    OphtalmohypermetropieOGcom,
    Ophtalmoivt_anti_vegfOD,
    Ophtalmoivt_anti_vegfODcom,
    Ophtalmoivt_anti_vegfOG,
    Ophtalmoivt_anti_vegfOGcom,
    OphtalmokeratconeOD,
    OphtalmokeratconeODcom,
    OphtalmokeratconeOG,
    OphtalmokeratconeOGcom,
    Ophtalmolaser_dehiscences_retinienneOD,
    Ophtalmolaser_dehiscences_retinienneODcom,
    Ophtalmolaser_dehiscences_retinienneOG,
    Ophtalmolaser_dehiscences_retinienneOGcom,
    OphtalmopprOD,
    OphtalmopprODcom,
    OphtalmopprOG,
    OphtalmopprOGcom,
    Ophtalmoretinopathie_diabetiqueOD,
    Ophtalmoretinopathie_diabetiqueODcom,
    Ophtalmoretinopathie_diabetiqueOG,
    Ophtalmoretinopathie_diabetiqueOGcom,
    OphtalmostrabismeOD,
    OphtalmostrabismeODcom,
    OphtalmostrabismeOG,
    OphtalmostrabismeOGcom,
    Ophtalmotraumatisme_oculaireOD,
    Ophtalmotraumatisme_oculaireODcom,
    Ophtalmotraumatisme_oculaireOG,
    Ophtalmotraumatisme_oculaireOGcom,
    Ophtalmotravail_prolongee_en_vpCheck,
    OphtalmoVisibleametropieForte,
    OphtalmoVisibleastigmatisme,
    OphtalmoVisibleautomedication_collyre,
    OphtalmoVisiblechir_glaucome,
    OphtalmoVisiblechir_pterygion,
    OphtalmoVisiblechir_strabisme,
    OphtalmoVisiblechirurgie_de_cataracte,
    OphtalmoVisiblechirurgie_palpebrale,
    OphtalmoVisiblechirurgie_refractive,
    OphtalmoVisiblechirurgie_vitreo_retinienne,
    OphtalmoVisibledcrs,
    OphtalmoVisibledecollement_de_retine,
    OphtalmoVisibleglaucome,
    OphtalmoVisiblehypermetropie,
    OphtalmoVisibleivt_anti_vegf,
    OphtalmoVisiblekeratcone,
    OphtalmoVisiblelaser_dehiscences_retinienne,
    OphtalmoVisiblemyopie,
    OphtalmoVisibleppr,
    OphtalmoVisibleretinopathie_diabetique,
    OphtalmoVisiblestrabisme,
    OphtalmoVisibletraitement_amblyopie,
    OphtalmoVisibletraumatisme_oculaire,
    OphtalmoVisibletravail_prolongee_en_vp,
    OphtalmoVisibleautres,
    GenerauxVisiblecardiopathie,
    GenerauxVisibleallergies,
    GenerauxVisibletabac,
    GenerauxVisibledysthyroidie,
    GenerauxVisibleobesite,
    GenerauxVisibledyslipidemie,
    GenerauxVisiblegrossesse,
    GenerauxVisibleanticoagulants,
    GenerauxVisibleasthme,
    GenerauxVisiblehta,
    GenerauxVisiblediabete,
    GenerauxVisibleautres,
    FamiliauxVisibleAmetropie_forte,
    FamiliauxVisibleautres,
    FamiliauxVisibleglaucome,
    FamiliauxVisiblekeratocone,
    FamiliauxVisibleretinopathie,
    FamiliauxVisiblestrabisme,
  };
  let Cleaned = {};

  for (const [key, value] of Object.entries(toClean)) {
    if (value === undefined) {
      Cleaned[key] = "";
    } else {
      Cleaned[key] = value;
    }
    // console.log(`${key}: ${value}`);
  }

  // console.log({ Cleaned });

  let anArray = [];
  if (FamiliauxVisibleAmetropie_forte) {
    let step1 = {};

    step1.categorie = "Antécédents Familiaux";
    step1.od = Familiauxametropie_forte;
    step1.commentaire = "";
    step1.commentaire2 = "";
    step1.nom = "Amétropie forte";
    anArray = [...anArray, step1];
  }

  if (FamiliauxVisibleglaucome) {
    let step3 = {};
    step3.categorie = "Antécédents Familiaux";
    step3.od = Familiauxglaucome;
    step3.commentaire = "";
    step3.commentaire2 = "";
    step3.nom = "Glaucome";
    anArray = [...anArray, step3];
  }

  if (FamiliauxVisiblekeratocone) {
    let step4 = {};
    step4.categorie = "Antécédents Familiaux";
    step4.od = Familiauxkeratocone;
    step4.commentaire = "";
    step4.commentaire2 = "";
    step4.nom = "Kératocone";
    anArray = [...anArray, step4];
  }

  if (FamiliauxVisibleretinopathie) {
    let step5 = {};
    step5.categorie = "Antécédents Familiaux";
    step5.od = Familiauxretinopathie;
    step5.commentaire = "";
    step5.commentaire2 = "";
    step5.nom = "Rétinopathie";
    anArray = [...anArray, step5];
  }

  if (FamiliauxVisiblestrabisme) {
    let step6 = {};
    step6.categorie = "Antécédents Familiaux";
    step6.od = Familiauxstrabisme;
    step6.commentaire = "";
    step6.commentaire2 = "";
    step6.nom = "Strabisme";
    anArray = [...anArray, step6];
  }

  if (FamiliauxVisibleautres) {
    let step2 = {};
    step2.od = true;
    step2.categorie = "Antécédents Familiaux";
    step2.commentaire = Cleaned.FamiliauxautresCom;
    step2.commentaire2 = "";
    step2.nom = "Autres Familiaux";
    anArray = [...anArray, step2];
  }

  // ///////////////////////////////////////////
  if (GenerauxVisibleallergies) {
    let step7 = {};
    step7.categorie = "Antécédents Personnels Généraux";
    step7.od = Generauxallergies;
    step7.commentaire = "";
    step7.commentaire2 = "";
    step7.nom = "Allergies";
    anArray = [...anArray, step7];
  }

  if (GenerauxVisibletabac) {
    let step8 = {};
    step8.categorie = "Antécédents Personnels Généraux";
    step8.od = Generauxtabac;
    step8.commentaire = "";
    step8.commentaire2 = "";
    step8.nom = "Tabac";
    anArray = [...anArray, step8];
  }

  if (GenerauxVisibledysthyroidie) {
    let step9 = {};
    step9.categorie = "Antécédents Personnels Généraux";
    step9.od = Generauxdysthyroidie;
    step9.commentaire = "";
    step9.commentaire2 = "";
    step9.nom = "Dysthyroidie";
    anArray = [...anArray, step9];
  }

  if (GenerauxVisibleobesite) {
    let step10 = {};
    step10.categorie = "Antécédents Personnels Généraux";
    step10.od = Generauxobesite;
    step10.commentaire = "";
    step10.commentaire2 = "";
    step10.nom = "Obésité";
    anArray = [...anArray, step10];
  }

  if (GenerauxVisibledyslipidemie) {
    let step11 = {};
    step11.categorie = "Antécédents Personnels Généraux";
    step11.od = Generauxdyslipidemie;
    step11.commentaire = "";
    step11.commentaire2 = "";
    step11.nom = "Dyslipidemie";
    anArray = [...anArray, step11];
  }

  if (GenerauxVisiblegrossesse) {
    let step12 = {};
    step12.categorie = "Antécédents Personnels Généraux";
    step12.od = Generauxgrossesse;
    step12.commentaire = "";
    step12.commentaire2 = "";
    step12.nom = "Grossesse";
    anArray = [...anArray, step12];
  }

  if (GenerauxVisibleanticoagulants) {
    let step13 = {};
    step13.categorie = "Antécédents Personnels Généraux";
    step13.od = Generauxanticoagulants;
    step13.commentaire = "";
    step13.commentaire2 = "";
    step13.nom = "Anticoagulants";
    anArray = [...anArray, step13];
  }

  if (GenerauxVisibleasthme) {
    let step14 = {};
    step14.categorie = "Antécédents Personnels Généraux";
    step14.od = Generauxasthme;
    step14.commentaire = "";
    step14.commentaire2 = "";
    step14.nom = "Asthme";
    anArray = [...anArray, step14];
  }

  if (GenerauxVisiblehta) {
    let step15 = {};
    step15.categorie = "Antécédents Personnels Généraux";
    step15.od = Generauxhta;
    step15.commentaire = "";
    step15.commentaire2 = "";
    step15.nom = "HTA";
    anArray = [...anArray, step15];
  }

  if (GenerauxVisiblecardiopathie) {
    let step16 = {};
    step16.categorie = "Antécédents Personnels Généraux";
    step16.od = Generauxcardiopathie;
    step16.commentaire = "";
    step16.commentaire2 = "";
    step16.nom = "Cardiopathie";
    anArray = [...anArray, step16];
  }

  if (GenerauxVisiblediabete) {
    let step18 = {};
    step18.categorie = "Antécédents Personnels Généraux";
    step18.od = GenerauxdiabeteNID;
    // step18.commentaire = GenerauxdiabeteNIDcom
    step18.commentaire = `NID : ${Cleaned.GenerauxdiabeteNIDcom}`;

    step18.og = GenerauxdiabeteID;
    // step18.commentaire2 = GenerauxdiabeteIDcom
    step18.commentaire2 = `ID : ${Cleaned.GenerauxdiabeteIDcom}`;
    step18.nom = "Diabète";
    anArray = [...anArray, step18];
  }

  if (GenerauxVisibleautres) {
    let step17 = {};
    step17.od = true;
    step17.categorie = "Antécédents Personnels Généraux";
    step17.commentaire = Cleaned.GenerauxautresCom;
    step17.commentaire2 = "";
    step17.nom = "Autres Generaux";
    anArray = [...anArray, step17];
  }

  //////////////////////////////////////////////////////////
  if (OphtalmoVisiblechir_glaucome) {
    let step19 = {};
    step19.categorie = "Ant. Per. Oph. chirurgicaux";
    step19.od = Ophtalmochir_glaucomeOD;
    step19.commentaire = `OD : ${Cleaned.Ophtalmochir_glaucomeODcom}`;
    step19.og = Ophtalmochir_glaucomeOG;
    step19.commentaire2 = `OG : ${Cleaned.Ophtalmochir_glaucomeOGcom}`;
    step19.nom = "Chir. de Glaucome";
    anArray = [...anArray, step19];
  }

  if (OphtalmoVisiblechir_pterygion) {
    let step20 = {};
    step20.categorie = "Ant. Per. Oph. chirurgicaux";
    step20.od = Ophtalmochir_pterygionOD;
    step20.commentaire = `OD : ${Cleaned.Ophtalmochir_pterygionODcom}`;
    step20.og = Ophtalmochir_pterygionOG;
    step20.commentaire2 = `OG : ${Cleaned.Ophtalmochir_pterygionOGcom}`;
    step20.nom = "Chir. de ptérygion";
    anArray = [...anArray, step20];
  }

  if (OphtalmoVisiblechir_strabisme) {
    let step21 = {};
    step21.categorie = "Ant. Per. Oph. chirurgicaux";
    step21.od = Ophtalmochir_strabismeOD;
    step21.commentaire = `OD : ${Cleaned.Ophtalmochir_strabismeODcom}`;
    step21.og = Ophtalmochir_strabismeOG;
    step21.commentaire2 = `OG : ${Cleaned.Ophtalmochir_strabismeOGcom}`;
    step21.nom = "Chir. de Strabisme";
    anArray = [...anArray, step21];
  }

  if (OphtalmoVisiblechirurgie_de_cataracte) {
    let step22 = {};
    step22.categorie = "Ant. Per. Oph. chirurgicaux";
    step22.od = Ophtalmochirurgie_de_cataracteOD;
    step22.commentaire = `OD : ${Cleaned.Ophtalmochirurgie_de_cataracteODcom}`;
    step22.og = Ophtalmochirurgie_de_cataracteOG;
    step22.commentaire2 = `OG : ${Cleaned.Ophtalmochirurgie_de_cataracteOGcom}`;
    step22.nom = "Chir. de cataracte";
    anArray = [...anArray, step22];
  }

  if (OphtalmoVisiblechirurgie_palpebrale) {
    let step23 = {};
    step23.categorie = "Ant. Per. Oph. chirurgicaux";
    step23.od = Ophtalmochirurgie_palpebraleOD;
    step23.commentaire = `OD : ${Cleaned.Ophtalmochirurgie_palpebraleODcom}`;
    step23.og = Ophtalmochirurgie_palpebraleOG;
    step23.commentaire2 = `OG : ${Cleaned.Ophtalmochirurgie_palpebraleOGcom}`;
    step23.nom = "Chir. palpébrale";
    anArray = [...anArray, step23];
  }

  if (OphtalmoVisiblechirurgie_refractive) {
    let step24 = {};
    step24.categorie = "Ant. Per. Oph. chirurgicaux";
    step24.od = Ophtalmochirurgie_refractiveOD;
    step24.commentaire = `OD : ${Cleaned.Ophtalmochirurgie_refractiveODcom}`;
    step24.og = Ophtalmochirurgie_refractiveOG;
    step24.commentaire2 = `OG : ${Cleaned.Ophtalmochirurgie_refractiveOGcom}`;
    step24.nom = "Chir. réfractive";
    anArray = [...anArray, step24];
  }

  if (OphtalmoVisiblechirurgie_vitreo_retinienne) {
    let step25 = {};
    step25.categorie = "Ant. Per. Oph. chirurgicaux";
    step25.od = Ophtalmochirurgie_vitreo_retinienneOD;
    step25.commentaire = `OD : ${Cleaned.Ophtalmochirurgie_vitreo_retinienneODcom}`;
    step25.og = Ophtalmochirurgie_vitreo_retinienneOG;
    step25.commentaire2 = `OG : ${Cleaned.Ophtalmochirurgie_vitreo_retinienneOGcom}`;
    step25.nom = "Chir. vitréo-réti.";
    anArray = [...anArray, step25];
  }

  if (OphtalmoVisibledcrs) {
    let step26 = {};
    step26.categorie = "Ant. Per. Oph. chirurgicaux";
    step26.od = OphtalmodcrsOD;
    step26.commentaire = `OD : ${Cleaned.OphtalmodcrsODcom}`;
    step26.og = OphtalmodcrsOG;
    step26.commentaire2 = `OG : ${Cleaned.OphtalmodcrsOGcom}`;
    step26.nom = "DCRS";
    anArray = [...anArray, step26];
  }

  if (OphtalmoVisiblelaser_dehiscences_retinienne) {
    let step27 = {};
    step27.categorie = "Ant. Per. Oph. chirurgicaux";
    step27.od = Ophtalmolaser_dehiscences_retinienneOD;
    step27.commentaire = `OD : ${Cleaned.Ophtalmolaser_dehiscences_retinienneODcom}`;
    step27.og = Ophtalmolaser_dehiscences_retinienneOG;
    step27.commentaire2 = `OG : ${Cleaned.Ophtalmolaser_dehiscences_retinienneOGcom}`;
    step27.nom = "Laser déhiscences";
    anArray = [...anArray, step27];
  }

  if (OphtalmoVisibleppr) {
    let step28 = {};
    step28.categorie = "Ant. Per. Oph. chirurgicaux";
    step28.od = OphtalmopprOD;
    step28.commentaire = `OD : ${Cleaned.OphtalmopprODcom}`;
    step28.og = OphtalmopprOG;
    step28.commentaire2 = `OG : ${Cleaned.OphtalmopprOGcom}`;
    step28.nom = "PPR";
    anArray = [...anArray, step28];
  }

  ////////////////////////////////////////////////////////////////////

  if (OphtalmoVisibleametropieForte) {
    let step29 = {};
    step29.categorie = "Ant. Per. Ophtalmologiques";
    step29.od = OphtalmoametropieForteOD;
    step29.commentaire = `OD : ${Cleaned.OphtalmoametropieForteODcom}`;
    step29.og = OphtalmoametropieForteOG;
    step29.commentaire2 = `OG : ${Cleaned.OphtalmoametropieForteOGcom}`;
    step29.nom = "Amétropie forte";
    anArray = [...anArray, step29];
  }

  if (OphtalmoVisibleastigmatisme) {
    let step30 = {};
    step30.categorie = "Ant. Per. Ophtalmologiques";
    step30.od = OphtalmoastigmatismeOD;
    step30.commentaire = `OD : ${Cleaned.OphtalmoastigmatismeODcom}`;
    step30.og = OphtalmoastigmatismeOG;
    step30.commentaire2 = `OG : ${Cleaned.OphtalmoastigmatismeOGcom}`;
    step30.nom = "Astigmatisme";
    anArray = [...anArray, step30];
  }

  if (OphtalmoVisibleautomedication_collyre) {
    let step31 = {};
    step31.categorie = "Ant. Per. Ophtalmologiques";
    step31.od = Ophtalmoautomedication_collyreOD;
    step31.commentaire = `OD : ${Cleaned.Ophtalmoautomedication_collyreODcom}`;
    step31.og = Ophtalmoautomedication_collyreOG;
    step31.commentaire2 = `OG : ${Cleaned.Ophtalmoautomedication_collyreOGcom}`;
    step31.nom = "Auto Med collyre";
    anArray = [...anArray, step31];
  }

  if (OphtalmoVisibledecollement_de_retine) {
    let step32 = {};
    step32.categorie = "Ant. Per. Ophtalmologiques";
    step32.od = Ophtalmodecollement_de_retineOD;
    step32.commentaire = `OD : ${Cleaned.Ophtalmodecollement_de_retineODcom}`;
    step32.og = Ophtalmodecollement_de_retineOG;
    step32.commentaire2 = `OG : ${Cleaned.Ophtalmodecollement_de_retineOGcom}`;
    step32.nom = "Décol. de rétine";
    anArray = [...anArray, step32];
  }

  if (OphtalmoVisibleglaucome) {
    let step33 = {};
    step33.categorie = "Ant. Per. Ophtalmologiques";
    step33.od = OphtalmoglaucomeOD;
    step33.commentaire = `OD : ${Cleaned.OphtalmoglaucomeODcom}`;
    step33.og = OphtalmoglaucomeOG;
    step33.commentaire2 = `OG : ${Cleaned.OphtalmoglaucomeOGcom}`;
    step33.nom = "Glaucome";
    anArray = [...anArray, step33];
  }

  if (OphtalmoVisiblehypermetropie) {
    let step34 = {};
    step34.categorie = "Ant. Per. Ophtalmologiques";
    step34.od = OphtalmohypermetropieOD;
    step34.commentaire = `OD : ${Cleaned.OphtalmohypermetropieODcom}`;
    step34.og = OphtalmohypermetropieOG;
    step34.commentaire2 = `OG : ${Cleaned.OphtalmohypermetropieOGcom}`;
    step34.nom = "Hypermetropie";
    anArray = [...anArray, step34];
  }

  if (OphtalmoVisibleivt_anti_vegf) {
    let step35 = {};
    step35.categorie = "Ant. Per. Ophtalmologiques";
    step35.od = Ophtalmoivt_anti_vegfOD;
    step35.commentaire = `OD : ${Cleaned.Ophtalmoivt_anti_vegfODcom}`;
    step35.og = Ophtalmoivt_anti_vegfOG;
    step35.commentaire2 = `OG : ${Cleaned.Ophtalmoivt_anti_vegfOGcom}`;
    step35.nom = "IVT d’anti-VEGF";
    anArray = [...anArray, step35];
  }

  if (OphtalmoVisiblekeratcone) {
    let step36 = {};
    step36.categorie = "Ant. Per. Ophtalmologiques";
    step36.od = OphtalmokeratconeOD;
    step36.commentaire = `OD : ${Cleaned.OphtalmokeratconeODcom}`;
    step36.og = OphtalmokeratconeOG;
    step36.commentaire2 = `OG : ${Cleaned.OphtalmokeratconeOGcom}`;
    step36.nom = "Kératcone";
    anArray = [...anArray, step36];
  }

  if (OphtalmoVisiblemyopie) {
    let step37 = {};
    step37.categorie = "Ant. Per. Ophtalmologiques";
    step37.od = OphtalmoMyopieOD;
    step37.commentaire = `OD : ${Cleaned.OphtalmoMyopieODcom}`;
    step37.og = OphtalmoMyopieOG;
    step37.commentaire2 = `OG : ${Cleaned.OphtalmoMyopieOGcom}`;
    step37.nom = "Myopie";
    anArray = [...anArray, step37];
  }

  if (OphtalmoVisibleretinopathie_diabetique) {
    let step38 = {};
    step38.categorie = "Ant. Per. Ophtalmologiques";
    step38.od = Ophtalmoretinopathie_diabetiqueOD;
    step38.commentaire = `OD : ${Cleaned.Ophtalmoretinopathie_diabetiqueODcom}`;
    step38.og = Ophtalmoretinopathie_diabetiqueOG;
    step38.commentaire2 = `OG : ${Cleaned.Ophtalmoretinopathie_diabetiqueOGcom}`;
    step38.nom = "Rétinopathie diab.";
    anArray = [...anArray, step38];
  }

  if (OphtalmoVisiblestrabisme) {
    let step39 = {};
    step39.categorie = "Ant. Per. Ophtalmologiques";
    step39.od = OphtalmostrabismeOD;
    step39.commentaire = `OD : ${Cleaned.OphtalmostrabismeODcom}`;
    step39.og = OphtalmostrabismeOG;
    step39.commentaire2 = `OG : ${Cleaned.OphtalmostrabismeOGcom}`;
    step39.nom = "Strabisme";
    anArray = [...anArray, step39];
  }

  if (OphtalmoVisibletraumatisme_oculaire) {
    let step41 = {};
    step41.categorie = "Ant. Per. Ophtalmologiques";
    step41.od = Ophtalmotraumatisme_oculaireOD;
    step41.commentaire = `OD : ${Cleaned.Ophtalmotraumatisme_oculaireODcom}`;
    step41.og = Ophtalmotraumatisme_oculaireOG;
    step41.commentaire2 = `OG : ${Cleaned.Ophtalmotraumatisme_oculaireOGcom}`;
    step41.nom = "Traum. oculaire";
    anArray = [...anArray, step41];
  }

  if (OphtalmoVisibletraitement_amblyopie) {
    let step40 = {};
    step40.categorie = "Ant. Per. Ophtalmologiques";
    step40.od = OphtalmoTraitement_amblyopie;
    step40.commentaire = "";
    step40.commentaire2 = "";
    step40.nom = "Trait. d’amblyopie";
    anArray = [...anArray, step40];
  }

  if (OphtalmoVisibletravail_prolongee_en_vp) {
    let step42 = {};
    step42.categorie = "Ant. Per. Ophtalmologiques";
    step42.od = Ophtalmotravail_prolongee_en_vpCheck;
    step42.commentaire = "";
    step42.commentaire2 = "";
    step42.nom = "Trav. prolongée VP";
    anArray = [...anArray, step42];
  }

  let step43 = {};
  step43.od = true;
  step43.categorie = "Ant. Per. Ophtalmologiques";
  step43.commentaire = Cleaned.OphtalmoautresCom;
  step43.commentaire2 = "";
  step43.nom = "Autres";
  anArray = [...anArray, step43];

  useEffect(
    () => {
      setQuestionnaireData(anArray);
    },

    // eslint-disable-next-line
    [NewData]
  );
  let CourrierArray = [];
  if (anArray) {
    // eslint-disable-next-line
    CourrierArray = anArray.filter(function (el) {
      if (!el.og) {
        el.commentaire2 = "";
      }
      if (!el.od) {
        el.commentaire = "";
      }

      return el.nom; // Changed this so a home would match
    });
  }

  let newArray = [];
  let newArray2 = [];
  let newArray3 = [];
  let newArray4 = [];

  if (questionnaireData) {
    newArray = questionnaireData.filter(function (el) {
      return el.categorie === "Ant. Per. Ophtalmologiques"; // Changed this so a home would match
    });
  }
  if (questionnaireData) {
    newArray2 = questionnaireData.filter(function (el) {
      return el.categorie === "Ant. Per. Oph. chirurgicaux"; // Changed this so a home would match
    });
  }
  if (questionnaireData) {
    newArray3 = questionnaireData.filter(function (el) {
      return el.categorie === "Antécédents Personnels Généraux"; // Changed this so a home would match
    });
  }
  if (questionnaireData) {
    newArray4 = questionnaireData.filter(function (el) {
      return el.categorie === "Antécédents Familiaux"; // Changed this so a home would match
    });
  }

  let Def_1920_X_1014 = (
    <Container className="fixing_Consultation_layout">
      <Grid columns={2} divided className="fixingWidthOf3Tables">
        <Grid.Row className="FixPadding">
          <Grid.Column width={4} className="consultationGrid">
            <Card className="cardWidth">
              <Card.Content>
                <ModalUpload />
                <ModalUpdatePatient />
                <Card.Header>
                  {PatientelleState?.civilite} {PatientelleState?.nom}{" "}
                  {PatientelleState?.prenom}
                </Card.Header>
                <Card.Meta className="MetaAGE">
                  {Math.round(PatientelleState?.AGEPATIENT) > 1
                    ? `${Math.round(PatientelleState?.AGEPATIENT)} ans`
                    : `${Math.round(PatientelleState?.AGEPATIENT * 12)} mois`}
                </Card.Meta>
                <Card.Description>
                  <div
                    style={{
                      paddingBottom: "0.2rem",
                    }}
                  >
                    <strong>Mutuelle </strong>: {PatientelleState?.nom_mutuelle}
                  </div>
                  <div
                    style={{
                      paddingBottom: "0.2rem",
                    }}
                  >
                    <strong>Tel </strong>: {PatientelleState?.tel}
                    <br />
                  </div>
                  <div
                    style={{
                      paddingBottom: "0.2rem",
                    }}
                  >
                    <strong>Com. Accueil</strong>:{" "}
                    <span className="Com_Accueil">
                      {PatientelleState?.commentaire_sur_patient}
                    </span>
                  </div>
                </Card.Description>
              </Card.Content>
            </Card>
            <Card className="cardWidth">
              <Card.Content>
                <ModalAddToWaitingList getAtesData={getAtesData} />
                <ModalPayment />
                <ModalPaymentHistoric />

                <Card.Header>Actes de la journée</Card.Header>
                <Card.Meta className="MetaAGE">{date_Lisible}</Card.Meta>
                <Card.Description>
                  {PatientelleState.products?.map((item, i) => (
                    <div
                      key={i}
                      style={{
                        paddingBottom: "0.3rem",
                      }}
                    >
                      <strong>{item.nom_acte} </strong>:{" "}
                      {item.prix_acte - item.remise + item.suplement} DH
                    </div>
                  ))}
                </Card.Description>
              </Card.Content>
            </Card>
            <Segment className="finPadding">
              <FormulairesAntecedents
                getQuestionsOneUser22={getQuestionsOneUser22}
                NewData={NewData}
                IsTablet={false}
              />
            </Segment>
            <Card className="cardWidth">
              <Card.Content>
                {/* <Card.Header>Chronomètre</Card.Header>
                            <Card.Meta className="MetaAGE"></Card.Meta> */}
                <Card.Description>
                  <IntervalReady returnToWaitingList={returnToWaitingList} />
                </Card.Description>
              </Card.Content>
            </Card>
          </Grid.Column>
          <Grid.Column width={12} className="consultationGrid">



            <Grid divided='vertically'>
              <Grid.Row columns={2} className="paddingbottomzero">
                <Grid.Column className="centerText">

                  Pathologie principale

                </Grid.Column>
                <Grid.Column className="centerText2">

                  Allergie connue

                </Grid.Column>
              </Grid.Row>
            </Grid>






            <Segment className="finPaddingAndDisplayFlex">

              <AutoComplete
                className="testingthetest"
                filterOption={true}
                value={PathoAllergie[0]?.pathologie_principale?.toUpperCase()}
                options={OptionsPhatologie}
                style={{ width: "50%", textAlign: "center" }}
                onSelect={onSelect2}
                onChange={onChange2}
                placeholder=" Pathologie principale"
                onKeyDown={handleKeyDown2}
              />
              <CrudOptions category={2} />

              <AutoComplete
                className="testingthetest2"
                filterOption={true}
                value={PathoAllergie[0]?.allergie_connue?.toUpperCase()}
                options={OptionsAllergie}
                style={{ width: "50%", textAlign: "center" }}
                onSelect={onSelect1}
                onChange={onChange1}
                placeholder="Allergie connue"
                onKeyDown={handleKeyDown}
              />

              <CrudOptions category={1} />

            </Segment>

            <Segment className="finPadding">
              <Bloc3
                userInformation={PatientelleState}
                questionnaireData={questionnaireData}
              />
            </Segment>
          </Grid.Column>
        </Grid.Row>
      </Grid>
    </Container>
  );

  let Def_768_X_1024 = (
    <div className="fixing_Consultation_layout">
      {/* <Grid.Column width={4} className="consultationGrid"> */}
      <Card.Group
        itemsPerRow={2}
        className="MarginRightFixPortrait"
        stackable
      // doubling
      >
        <Card>
          <Card.Content>
            <ModalUpload />
            <ModalUpdatePatient />

            <Card.Header>
              {PatientelleState?.civilite} {PatientelleState?.nom}{" "}
              {PatientelleState?.prenom}
            </Card.Header>
            <Card.Meta className="MetaAGE">
              {Math.round(PatientelleState?.AGEPATIENT) > 1
                ? `${Math.round(PatientelleState?.AGEPATIENT)} ans`
                : `${Math.round(PatientelleState?.AGEPATIENT * 12)} mois`}
            </Card.Meta>
            <Card.Description>
              <div
                style={{
                  paddingBottom: "0.2rem",
                }}
              >
                <strong>Mutuelle </strong>: {PatientelleState?.nom_mutuelle}
              </div>
              <div
                style={{
                  paddingBottom: "0.2rem",
                }}
              >
                <strong>Tel </strong>: {PatientelleState?.tel}
                <br />
              </div>
              <div
                style={{
                  paddingBottom: "0.2rem",
                }}
              >
                <strong>Com. Accueil</strong>:{" "}
                <span className="Com_Accueil">
                  {PatientelleState?.commentaire_sur_patient}
                </span>
              </div>
            </Card.Description>
          </Card.Content>
        </Card>
        <Card>
          <Card.Content>
            <ModalAddToWaitingList getAtesData={getAtesData} />
            <ModalPayment getAtesData={getAtesData} />
            <ModalPaymentHistoric />

            <Card.Header>Actes de la journée</Card.Header>
            <Card.Meta className="MetaAGE">{date_Lisible}</Card.Meta>
            <Card.Description>
              {PatientelleState.products?.map((item, i) => (
                <div
                  key={i}
                  style={{
                    paddingBottom: "0.3rem",
                  }}
                >
                  <strong>{item.nom_acte} </strong>:{" "}
                  {item.prix_acte - item.remise + item.suplement} DH
                </div>
              ))}
            </Card.Description>
          </Card.Content>
        </Card>
      </Card.Group>
      <Card.Group
        // className="MarginRightFixPortrait"
        // doubling
        itemsPerRow={1}
      >
        <Card>
          <Card.Content>
            {/* <br /> */}
            <Grid stackable>
              <Grid.Row className="NoPaddingTitle">
                <Grid.Column
                  width={14}
                  textAlign="center"
                  verticalAlign="middle"
                >
                  <h3>Antécédents du patient</h3>
                </Grid.Column>
                <Grid.Column width={2} textAlign="center">
                  <ModalAntecedents
                    getQuestionsOneUser22={getQuestionsOneUser22}
                    NewData={NewData}
                    IsTablet={true}
                  />
                </Grid.Column>
              </Grid.Row>

              <Grid.Row className="NoPadding">
                <Grid.Column width={8}>
                  {newArray.length > 0 ? (
                    <Card.Meta className="MetaAGE2">
                      Ant. Per. Ophtalmo
                    </Card.Meta>
                  ) : null}
                  <Card.Description>
                    {newArray.map((item, index) => (
                      <div
                        key={index}
                        style={{
                          paddingBottom: "0.3rem",
                        }}
                      >
                        <span
                          style={{
                            fontWeight: "600",
                            paddingRight: "0.3rem",
                          }}
                        >
                          {item.nom}
                        </span>{" "}
                        {item.od
                          ? item.commentaire === "OD : "
                            ? "OD"
                            : `${item.commentaire}`
                          : item.commentaire === "OD : "
                            ? null
                            : item.commentaire}
                        <span
                          style={{
                            paddingLeft: "0.3rem",
                          }}
                        >
                          {" "}
                          {item.og
                            ? item.commentaire2 === "OG : "
                              ? "OG"
                              : `${item.commentaire2}`
                            : null}{" "}
                        </span>
                      </div>
                    ))}
                  </Card.Description>
                </Grid.Column>
                <Grid.Column width={8}>
                  {newArray2.length > 0 ? (
                    <Card.Meta className="MetaAGE2">
                      Ant. Per. Oph. chirurgicaux
                    </Card.Meta>
                  ) : null}
                  <Card.Description>
                    {newArray2.map((item, index) => (
                      <div
                        key={index}
                        style={{
                          paddingBottom: "0.3rem",
                        }}
                      >
                        <span
                          style={{
                            fontWeight: "600",
                            paddingRight: "0.3rem",
                          }}
                        >
                          {item.nom}
                        </span>{" "}
                        {item.od
                          ? item.commentaire === "OD : "
                            ? "OD"
                            : `${item.commentaire}`
                          : null}
                        <span
                          style={{
                            paddingLeft: "0.3rem",
                          }}
                        >
                          {" "}
                          {item.og
                            ? item.commentaire2 === "OG : "
                              ? "OG"
                              : `${item.commentaire2}`
                            : null}{" "}
                        </span>
                      </div>
                    ))}
                  </Card.Description>
                </Grid.Column>
              </Grid.Row>

              <Grid.Row>
                <Grid.Column width={8}>
                  {newArray3.length > 0 ? (
                    <Card.Meta className="MetaAGE2">
                      Ant. Per. Généraux
                    </Card.Meta>
                  ) : null}
                  <Card.Description>
                    {newArray3.map((item, index) => (
                      <div
                        key={index}
                        style={{
                          paddingBottom: "0.3rem",
                        }}
                      >
                        <span
                          style={{
                            fontWeight: "600",
                            paddingRight: "0.3rem",
                          }}
                        >
                          {item.nom}
                        </span>{" "}
                        {item.od
                          ? item.commentaire === "NID : "
                            ? "NID"
                            : `${item.commentaire}`
                          : item.commentaire === "NID : "
                            ? null
                            : item.commentaire}
                        <span
                          style={{
                            paddingLeft: "0.3rem",
                          }}
                        >
                          {" "}
                          {item.og
                            ? item.commentaire2 === "ID : "
                              ? "ID"
                              : `${item.commentaire2}`
                            : null}{" "}
                        </span>
                      </div>
                    ))}
                  </Card.Description>
                </Grid.Column>
                <Grid.Column width={8}>
                  {newArray4.length > 0 ? (
                    <Card.Meta className="MetaAGE2">
                      Antécédents Familiaux
                    </Card.Meta>
                  ) : null}
                  <Card.Description>
                    {newArray4.map((item, index) => (
                      <div
                        key={index}
                        style={{
                          paddingBottom: "0.3rem",
                        }}
                      >
                        {/* <span
                                                style={{
                                                    fontWeight: "600",
                                                }}
                                            > {item.nom}</span>  {item.commentaire ? `: ${item.commentaire}` : null} {item.commentaire2 ? item.commentaire2 : null} */}
                        <span
                          style={{
                            fontWeight: "600",
                            paddingRight: "0.3rem",
                          }}
                        >
                          {item.nom}
                        </span>{" "}
                        {item.od
                          ? item.commentaire === "OD : "
                            ? "OD"
                            : `${item.commentaire}`
                          : item.commentaire}
                        <span
                          style={{
                            paddingLeft: "0.3rem",
                          }}
                        >
                          {" "}
                          {item.og
                            ? item.commentaire2 === "OG : "
                              ? "OG"
                              : `${item.commentaire2}`
                            : null}{" "}
                        </span>
                      </div>
                    ))}
                  </Card.Description>
                </Grid.Column>
              </Grid.Row>
            </Grid>
          </Card.Content>
        </Card>
        {/* {width >= 800 ? */}
        <Card>
          <Card.Content>
            {/* <Card.Header>Chronomètre</Card.Header>
                            <Card.Meta className="MetaAGE"></Card.Meta> */}
            <Card.Description>
              <IntervalReady returnToWaitingList={returnToWaitingList} />
            </Card.Description>
          </Card.Content>
        </Card>
        {/* :
          null
        } */}

      </Card.Group>
      {/* <Segment className="finPadding"><FormulairesAntecedents  userInformation={userInformation} getQuestionnaireData={getQuestionnaireData} /></Segment> */}
      {/* <Grid columns={1} divided className="fixingWidthOf3Tables" >
            <Grid.Row > */}
      {/* </Grid.Column> */}
      {/* <Grid.Column width={12} className="consultationGrid"> */}
      <Segment className="finPadding">
        <div
          id="myGrid"
          className="ag-theme-balham"
          // className="ag-theme-alpine"
          style={{
            height: "70px",
            // height: "91vh",
            width: "100%",
            // paddingTop: "0.2rem",
            // paddingBottom: "0.2rem",
          }}
        >
          <AgGridReact
            rowData={PathoAllergie}
            animateRows={true}
            sortingOrder={["desc", "asc", null]}
            onGridReady={onGridReady}
            columnDefs={columnDefs}
            defaultColDef={defaultColDef}
            rowSelection={"single"}
            // onSelectionChanged={onSelectionChanged}
            undoRedoCellEditing={true}
            undoRedoCellEditingLimit={40}
            onCellValueChanged={onCellValueChanged}
          ></AgGridReact>
        </div>
      </Segment>
      <Segment className="finPadding">
        <Bloc3
          userInformation={PatientelleState}
          questionnaireData={questionnaireData}
        />
      </Segment>
      {/* </Grid.Column> */}
      {/* </Grid.Row>
        </Grid> */}
    </div>
  );

  // function name(height, width) {
  //     if (height <= 1024 && width < 1360) {

  //         setNewHeightValue(false)

  //     }
  //     // else if (height === 702 && width === 1360) {

  //     //     setNewHeightValue(false)
  //     // }
  //     else {

  //         setNewHeightValue(true)

  //     }
  // }
  // useEffect(() => {

  //     name(height, width)
  //     return name(1024, 768)

  // }, [height, width])

  let ww;

  if (width < 1368) {
    ww = Def_768_X_1024;
  } else {
    ww = Def_1920_X_1014;
  }

  return (
    <>
      {/* <FormulairesAntecedentsEmpty ID={ID} getQuestionnaireData={getQuestionnaireData} /> */}
      {/* {NewHeightValue ? Def_1920_X_1014 : Def_768_X_1024} */}
      {ww}
      {/* <br></br>
      <br></br> */}
      <SpeedDialComponent />
    </>
  );
}

export default Consultation;
